<template>
    <div class="order-third order-body">
        <div class="order-third__complete">
            <!-- eslint-disable -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.488 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="#62725b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 4L12 14.01L9 11.01" stroke="#62725b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <!-- eslint-enable -->
            <div class="order-third__complete-content">
                <h5 class="order-third__complete-title">Объект успешно забронирован</h5>
                <p class="order-third__complete-text">Вы&nbsp;можете найти свой забронированный объект в&nbsp;разделе
                    &laquo;Бронирования и&nbsp;покупка&raquo; личного кабинета</p>

                <ButtonComponent
                    modify="button_theme_yuntolovo order-third__complete-button"
                    text="В личный кабинет"
                    @click="_goToCabinet" />
            </div>
        </div>

        <OrderObjectCard
            v-if="content?.object"
            title="Вы забронировали"
            modify="object-third__booking"
            :objectData="content.object"/>

        <OrderConditionalsComponent
            v-if="content?.conditionals && Object.keys(content.conditionals).length"
            modify="order-third__conditionals"
            title="Детали бронирования"
            :content="content.conditionals"/>
    </div>
</template>

<script>
import ButtonComponent from '@/components/ButtonComponent/ButtonComponent';
import OrderConditionalsComponent from '../OrderConditionalsComponent/OrderConditionalsComponent';
import OrderObjectCard from '../OrderObjectCard/OrderObjectCard';

export default {
    name: 'OrderThirdStepComponent',

    components: {
        ButtonComponent,
        OrderConditionalsComponent,
        OrderObjectCard
    },

    props: {
        content: {
            default: () => {
                return {};
            },
            type: Object
        },
        backLink: {
            default: '/content/booking',
            type   : String
        }
    },

    methods: {
        _goToCabinet() {
            if (!this.backLink) {
                return;
            }

            this.$router.push(this.backLink);
        }
    }
};
</script>

<style lang="scss">
@import './OrderThirdStepComponent';
</style>
